import { SafetyGogglesIcon } from './SafetyGogglesIcon';

/**
 * author: Michael Irigoyen
 * id 438888DA-342B-4861-95EA-026A3F4E2F95
 * name safety-goggles
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/safety-goggles.svg
 * tags
 * - Science 
 */
export const SafetyGlassesIcon = SafetyGogglesIcon;
export default SafetyGlassesIcon